import { i18n } from 'utils/i18n-util';

export const QUERY_KEYS = {
	COMPANY: 'COMPANYDETAIL',
	ME: 'ME',
	APPLICATION: 'APPLICATION',
	CLIENTS: 'CLIENTS',
	APPPLICATIONDATAACCESS: 'APPPLICATIONDATAACCESS',
	CLIENTUSERCONSENT: 'CLIENTUSERCONSENT',
	LEADCONTACT: 'LEADCONTACT'
};

export const ACTIONS = {
	GLOBAL_BANNER_SHOW: 'GLOBAL_BANNER/SHOW'
};

export const HOME_ROUTES = {
	Home: '/',
	Import: '/import',
	Templates: '/templates',
	Aliases: '/aliases',
	CustomMaps: '/custommaps',
	Registrations: '/registrations',
	Analytics: '/analytics',
	Migrations: '/migrations',
	Configs: '/configs',
	Export: '/export'
};

export const MAP_ACTIONS = {
	Select: '/select-map',
	Create: '/create-map',
	Edit: '/edit-map'
};

export const IMPORT_ROUTES = {
	Upload: HOME_ROUTES.Import + '/upload',
	SelectMap: HOME_ROUTES.Import + MAP_ACTIONS.Select,
	CreateMap: HOME_ROUTES.Import + MAP_ACTIONS.Create,
	EditMap: HOME_ROUTES.Import + MAP_ACTIONS.Edit,
	Validate: HOME_ROUTES.Import + '/validate',
	Process: HOME_ROUTES.Import + '/import'
};

export const MAP_MANAGER_ROUTES = {
	SelectMap: HOME_ROUTES.CustomMaps + MAP_ACTIONS.Select,
	CreateMap: HOME_ROUTES.CustomMaps + MAP_ACTIONS.Create,
	EditMap: HOME_ROUTES.CustomMaps + MAP_ACTIONS.Edit
};

export const TEMPLATE_ROUTES = {
	Upload: HOME_ROUTES.Templates + '/:mapId',
	MultiSheetUpload: HOME_ROUTES.Templates + '/multiSheet'
};

export const LEARN_MORE_LINK =
	'https://knowledge.paycor.com/en_US/data-imports-overview';

export const SKIP_TAXES_INFO = () => i18n('msg.skip.taxes.info');

export const DISABLE_CANCEL_INFO = () => i18n('msg.disable.cancel.info');

export const SKIP_TAXES_INFO_EXTENDED = () =>
	i18n('msg.skip.taxes.info.extended');

export const MULTISHEET_INFO = () => i18n('msg.multisheet.info');

export const MIGRATION_FAILED_INFO = () => i18n('msg.migration.failed.info');

export const MAPTYPE_TOOLTIP = () => i18n('msg.maptype.tooltip');

export const MAPFUNCTION_TOOLTIP = () => i18n('msg.mapfunction.tooltip');

export const SUSPENDED_INFO = () => i18n('msg.suspended.info');
